module.exports = __webpack_public_path__ + "img/icon-no-image.72a93121.svg";